/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tool_Discount_Copied_AriaInputs */

const en_directory_tool_discount_copied_aria = /** @type {(inputs: Directory_Tool_Discount_Copied_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount code copied`)
};

const zh_directory_tool_discount_copied_aria = /** @type {(inputs: Directory_Tool_Discount_Copied_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优惠码已复制`)
};

/**
* | output |
* | --- |
* | "Discount code copied" |
*
* @param {Directory_Tool_Discount_Copied_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_discount_copied_aria = /** @type {((inputs?: Directory_Tool_Discount_Copied_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_Discount_Copied_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_discount_copied_aria(inputs)
	return zh_directory_tool_discount_copied_aria(inputs)
});
export { directory_tool_discount_copied_aria as "directory.tool.discount_copied_aria" }